<template>
  <nav class="main-menu">
    <!-- Desktop Menu -->
    <div class="desktop-menu">
      <div class="menu-items">
        <router-link to="/" class="menu-item" exact>
          <span class="item-icon">📅</span>
          <span class="item-text">Kalendarz</span>
        </router-link>
        
        <router-link to="/eventlist" class="menu-item" :class="{ 'active-installations': isInstallationsRoute }">
          <span class="item-icon">🔧</span>
          <span class="item-text">Instalacje</span>
        </router-link>
        
        <router-link to="/warranty-service" class="menu-item" :class="{ 'active-warranty': isWarrantyRoute }">
          <span class="item-icon">🛠️</span>
          <span class="item-text">Serwis</span>
        </router-link>
        
        <router-link to="/contractors" class="menu-item" :class="{ 'active-contractors': isContractorsRoute }">
          <span class="item-icon">👥</span>
          <span class="item-text">Kontrahenci</span>
        </router-link>
        
        <router-link to="/offers-archive" class="menu-item" :class="{ 'active-offers': isOffersRoute }">
          <span class="item-icon">📋</span>
          <span class="item-text">Oferty</span>
        </router-link>
        
        <router-link to="/payments" class="menu-item" :class="{ 'active-payment': isPaymentsRoute }">
          <span class="item-icon">💰</span>
          <span class="item-text">Płatności</span>
        </router-link>
        
        <router-link to="/magazine" class="menu-item" :class="{ 'active-magazine': isMagazineRoute }">
          <span class="item-icon">📦</span>
          <span class="item-text">Magazyn</span>
        </router-link>
        
        <router-link to="/meetings-archive" class="menu-item" :class="{ 'active-meetings': isMeetingsRoute }">
          <span class="item-icon">🤝</span>
          <span class="item-text">Spotkania</span>
        </router-link>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div class="mobile-menu">
      <div class="mobile-header">
        <button @click="toggleMobileMenu" class="hamburger" :class="{'active': mobileMenuOpen}">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      
      <transition name="slide">
        <div v-if="mobileMenuOpen" class="mobile-menu-items">
          <router-link to="/" class="mobile-menu-item" exact @click.native="closeMobileMenu">
            <span class="item-icon">📅</span>
            <span class="item-text">Kalendarz</span>
          </router-link>
          
          <router-link to="/eventlist" class="mobile-menu-item" :class="{ 'active-installations': isInstallationsRoute }" @click.native="closeMobileMenu">
            <span class="item-icon">🔧</span>
            <span class="item-text">Instalacje</span>
          </router-link>
          
          <router-link to="/warranty-service" class="mobile-menu-item" :class="{ 'active-warranty': isWarrantyRoute }" @click.native="closeMobileMenu">
            <span class="item-icon">🛠️</span>
            <span class="item-text">Serwis</span>
          </router-link>
          
          <router-link to="/contractors" class="mobile-menu-item" :class="{ 'active-contractors': isContractorsRoute }" @click.native="closeMobileMenu">
            <span class="item-icon">👥</span>
            <span class="item-text">Kontrahenci</span>
          </router-link>
          
          <router-link to="/offers-archive" class="mobile-menu-item" :class="{ 'active-offers': isOffersRoute }" @click.native="closeMobileMenu">
            <span class="item-icon">📋</span>
            <span class="item-text">Oferty</span>
          </router-link>
          
          <router-link to="/payments" class="mobile-menu-item" :class="{ 'active-payment': isPaymentsRoute }" @click.native="closeMobileMenu">
            <span class="item-icon">💰</span>
            <span class="item-text">Płatności</span>
          </router-link>
          
          <router-link to="/magazine" class="mobile-menu-item" :class="{ 'active-magazine': isMagazineRoute }" @click.native="closeMobileMenu">
            <span class="item-icon">📦</span>
            <span class="item-text">Magazyn</span>
          </router-link>
          
          <router-link to="/meetings-archive" class="mobile-menu-item" :class="{ 'active-meetings': isMeetingsRoute }" @click.native="closeMobileMenu">
            <span class="item-icon">🤝</span>
            <span class="item-text">Spotkania</span>
          </router-link>
        </div>
      </transition>
    </div>
  </nav>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      mobileMenuOpen: false,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    },
  },
  computed: {
    ...mapState(["userProfile"]),
    isPaymentsRoute() {
      const path = this.$route.path;
      return path === '/payments' || path.startsWith('/payments-') || path === '/addpayment';
    },
    isContractorsRoute() {
      const path = this.$route.path;
      return path === '/contractors' || path === '/company' || path === '/customer' || path === '/addcontractor' || path === '/addcompany' || path === '/addcustomer';
    },
    isMagazineRoute() {
      const path = this.$route.path;
      return path === '/magazine' || path === '/add-magazine-item';
    },
    isMeetingsRoute() {
      const path = this.$route.path;
      return path === '/meetings-archive' || path === '/add-new-meeting';
    },
    isOffersRoute() {
      const path = this.$route.path;
      return path === '/offers-archive' || path === '/offers';
    },
    isInstallationsRoute() {
      const path = this.$route.path;
      return path === '/eventlist' || path === '/installation' || path === '/addinstallation';
    },
    isWarrantyRoute() {
      const path = this.$route.path;
      return path === '/warranty-service';
    },
  },
};
</script>

<style scoped>
/* MAIN MENU CONTAINER */
.main-menu {
  position: relative;
  z-index: 1000;
}

/* ===== DESKTOP MENU ===== */
.desktop-menu {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 8px 24px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
  position: relative;
  z-index: 100;
}

.menu-brand {
  display: none;
}

.menu-items {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  justify-content: center;
  max-width: 1400px;
  margin: 0 auto;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 24px;
  color: white;
  text-decoration: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  letter-spacing: 0.3px;
}

.menu-item:hover {
  background: rgba(255, 255, 255, 0.25);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.menu-item.router-link-active,
.menu-item.active-payment,
.menu-item.active-contractors,
.menu-item.active-magazine,
.menu-item.active-meetings,
.menu-item.active-offers,
.menu-item.active-installations {
  background: white;
  color: #667eea;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  font-weight: 700;
}

.menu-item.active-payment {
  background: white;
  color: #667eea;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  font-weight: 700;
}

.item-icon {
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-text {
  white-space: nowrap;
}

/* ===== MOBILE MENU ===== */
.mobile-menu {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.mobile-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 12px 20px;
  box-shadow: 0 -2px 12px rgba(102, 126, 234, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.mobile-brand {
  display: none;
}

.hamburger {
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 0;
}

.hamburger span {
  width: 100%;
  height: 3px;
  background: white;
  border-radius: 3px;
  transition: all 0.3s ease;
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(8px, 8px);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(8px, -8px);
}

.mobile-menu-items {
  background: white;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  max-height: 70vh;
  overflow-y: auto;
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
}

.mobile-menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 20px;
  color: #2c3e50;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s ease;
}

.mobile-menu-item:hover {
  background: #f8f9fa;
}

.mobile-menu-item.router-link-active,
.mobile-menu-item.active-payment,
.mobile-menu-item.active-contractors,
.mobile-menu-item.active-magazine,
.mobile-menu-item.active-meetings,
.mobile-menu-item.active-offers,
.mobile-menu-item.active-installations {
  background: linear-gradient(90deg, rgba(102, 126, 234, 0.15) 0%, transparent 100%);
  color: #667eea;
  font-weight: 600;
}

.mobile-menu-item.active-payment {
  background: linear-gradient(90deg, rgba(102, 126, 234, 0.15) 0%, transparent 100%);
  color: #667eea;
  font-weight: 600;
}

.mobile-menu-item .item-icon {
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mobile-menu-footer {
  display: none;
}

/* TRANSITIONS */
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter, .slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 1200px) {
  .menu-items {
    gap: 4px;
  }
  
  .menu-item {
    padding: 10px 16px;
    font-size: 14px;
  }
  
  .item-icon {
    font-size: 18px;
  }
}

@media (max-width: 1024px) {
  .desktop-menu {
    display: none;
  }
  
  .mobile-menu {
    display: block;
  }
}
</style>